import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("nakama_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    if (status === 403 && url.includes("/barber/")) {
      const detail = err?.response?.data?.detail;
      window.dispatchEvent(new CustomEvent("barber-locked", { detail: typeof detail === "string" ? detail : "Acceso no disponible en este momento." }));
    }
    if (status === 401) {
      const hadToken = !!localStorage.getItem("nakama_token");
      const p = window.location.pathname;
      if (hadToken && (p.startsWith("/admin") || p.startsWith("/barber"))) {
        const detail = err?.response?.data?.detail;
        let reason = "expired";
        if (typeof detail === "string") {
          if (detail.includes("inactividad")) reason = "inactivity";
          else if (detail.includes("otro dispositivo")) reason = "other-device";
        }
        localStorage.removeItem("nakama_token");
        window.location.assign(`/login?reason=${reason}`);
      }
    }
    return Promise.reject(err);
  }
);

/* Cache en memoria para datos que casi no cambian (barberos, servicios, config).
   Evita volver a pedirlos en cada pestaña. TTL 60s + invalidación en cualquier mutación. */
const CACHEABLE = ["/barbers", "/services", "/config", "/barber/services", "/barber/products",
                   "/public/services", "/public/barbers", "/public/config"];
const CACHE_TTL = 60000;
const _getCache = new Map();
const _pathOf = (url) => (url || "").split("?")[0];

export function clearApiCache() { _getCache.clear(); }

const _origGet = api.get.bind(api);
api.get = (url, config) => {
  if (CACHEABLE.includes(_pathOf(url))) {
    const hit = _getCache.get(url);
    if (hit && Date.now() - hit.t < CACHE_TTL) return hit.p;
    const p = _origGet(url, config);
    _getCache.set(url, { t: Date.now(), p });
    p.catch(() => _getCache.delete(url));
    return p;
  }
  return _origGet(url, config);
};

// Cualquier edición (POST/PUT/PATCH/DELETE) limpia el cache para no mostrar datos viejos.
["post", "put", "patch", "delete"].forEach((m) => {
  const orig = api[m].bind(api);
  api[m] = (...args) => {
    const r = orig(...args);
    _getCache.clear();
    return r;
  };
});

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Ocurrió un error";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && x.msg) || JSON.stringify(x)).join(" ");
  if (d && typeof d.msg === "string") return d.msg;
  return String(d);
}
